export class trackingModel {
    


    /**
     *
     */
    constructor(
        
        public uid:string,     
        public date_create:string,
        public level:string,
        public calling:boolean=false, // Le client a t-il été joint?
        public code_compagine ?:string,
        public observation ?:string,
        public produit ?:string,
        public autre ?:string

        ) {
        
    }

    }